// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_INWARD_REQUEST_DK = 'FETCH_YARN_INWARD_REQUEST_DK';
export const FETCH_YARN_INWARD_SUCCESS_DK = 'FETCH_YARN_INWARD_SUCCESS_DK';
export const FETCH_YARN_INWARD_FAILURE_DK = 'FETCH_YARN_INWARD_FAILURE_DK';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_YARN_INWARD_REQUEST_DK = 'CREATE_YARN_INWARD_REQUEST_DK';
export const CREATE_YARN_INWARD_SUCCESS_DK = 'CREATE_YARN_INWARD_SUCCESS_DK';
export const CREATE_YARN_INWARD_FAILURE_DK = 'CREATE_YARN_INWARD_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_YARN_INWARD_DK = 'CREATE_USER_FORM_YARN_INWARD_DK';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_YARN_INWARD_REQUEST_DK = 'UPDATE_YARN_INWARD_REQUEST_DK';
export const UPDATE_YARN_INWARD_SUCCESS_DK = 'UPDATE_YARN_INWARD_SUCCESS_DK';
export const UPDATE_YARN_INWARD_FAILURE_DK = 'UPDATE_YARN_INWARD_FAILURE_DK';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_YARN_INWARD_REQUEST_DK = 'FETCH_SINGLE_YARN_INWARD_REQUEST_DK';
export const FETCH_SINGLE_YARN_INWARD_SUCCESS_DK = 'FETCH_SINGLE_YARN_INWARD_SUCCESS_DK';
export const FETCH_SINGLE_YARN_INWARD_FAILURE_DK = 'FETCH_SINGLE_YARN_INWARD_FAILURE_DK';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_YARN_INWARD_REQUEST_DK = 'DELETE_YARN_INWARD_REQUEST_DK';
export const DELETE_YARN_INWARD_SUCCESS_DK = 'DELETE_YARN_INWARD_SUCCESS_DK';
export const DELETE_YARN_INWARD_FAILURE_DK = 'DELETE_YARN_INWARD_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_PENDING_YARN_PO_IN_INWARD_REQUEST_DK = 'FETCH_PENDING_YARN_PO_IN_INWARD_REQUEST_DK';
export const FETCH_PENDING_YARN_PO_IN_INWARD_SUCCESS_DK = 'FETCH_PENDING_YARN_PO_IN_INWARD_SUCCESS_DK';
export const FETCH_PENDING_YARN_PO_IN_INWARD_FAILURE_DK = 'FETCH_PENDING_YARN_PO_IN_INWARD_FAILURE_DK';

export const RESET_FORM_DATA_WITHOUT_INWARD_ID_DK = 'RESET_FORM_DATA_WITHOUT_INWARD_ID_DK';
export const SET_ACTIVE_KEY_YARN_INWARD_DK = 'SET_ACTIVE_KEY_YARN_INWARD_DK';

// USERFORM RESET

export const YARN_INWARD_USERFORM_RESET_DK = 'YARN_INWARD_USERFORM_RESET_DK';

// navigate to unit component
export const NAVIGATE_YARN_INWARD_DETAILS_DK = 'NAVIGATE_YARN_INWARD_DETAILS_DK';
// navigate to company component
export const NAVIGATE_YARN_INWARD_DK = 'NAVIGATE_YARN_INWARD_DK';

export const SET_PENDING_GRID_NAME_YARN_INWARD_DK = 'SET_PENDING_GRID_NAME_YARN_INWARD_DK';
export const SET_UNIT_NAME_YARN_INWARD_DK = 'SET_UNIT_NAME_YARN_INWARD_DK';

export const FETCH_COMPLETE_YARN_PO_IN_INWARD_REQUEST_DK = 'FETCH_COMPLETE_YARN_PO_IN_INWARD_REQUEST_DK';
export const FETCH_COMPLETE_YARN_PO_IN_INWARD_SUCCESS_DK = 'FETCH_COMPLETE_YARN_PO_IN_INWARD_SUCCESS_DK';
export const FETCH_COMPLETE_YARN_PO_IN_INWARD_FAILURE_DK = 'FETCH_COMPLETE_YARN_PO_IN_INWARD_FAILURE_DK';


export const FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK';
export const FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK';
export const FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK';